import { getIsChangingDeliveryMethodIsDisabled } from '@melio/ap-domain';
import { DeliveryMethod, DeliveryMethodType, Vendor } from '@melio/platform-api';

const getSkipDeliveryMethodStep = (
  actionToPerform: 'schedule' | 'edit',
  isDeliveryMethodSelectionStepVisited: boolean,
  deliveryMethod?: DeliveryMethod | null,
  deliveryMethodIdFromState?: string
) => {
  const isVirtualAccount = deliveryMethod?.type === DeliveryMethodType.VirtualAccount;

  if (deliveryMethod && getIsChangingDeliveryMethodIsDisabled(deliveryMethod)) {
    return true;
  }

  const isScheduledButNotVisited = actionToPerform === 'schedule' && !isDeliveryMethodSelectionStepVisited;
  const skipWhenNewDmCreatedInVendorDashboard = deliveryMethodIdFromState && isScheduledButNotVisited;
  const skipWhenDmExistOnVendor = deliveryMethod && !isVirtualAccount && isScheduledButNotVisited;

  return skipWhenNewDmCreatedInVendorDashboard || skipWhenDmExistOnVendor;
};

export const getSkipVendorEmail = (vendor?: Vendor) => vendor?.isManaged;

export const getVendorEmail = (vendor?: Vendor) => vendor?.contact?.email || '';

export const getSkipMemoToVendorStep = ({
  deliveryMethod,
  isCapitalOneRail,
  memoToVendorDeliveryMethodBlackList,
}: {
  deliveryMethod?: DeliveryMethod | null;
  isCapitalOneRail: boolean;
  memoToVendorDeliveryMethodBlackList: DeliveryMethodType[];
}) =>
  deliveryMethod?.type === DeliveryMethodType.BillerAccount ||
  deliveryMethod?.type === DeliveryMethodType.ManagedAccount ||
  isCapitalOneRail ||
  (deliveryMethod && memoToVendorDeliveryMethodBlackList.includes(deliveryMethod.type));

export type ActionToPerform = 'schedule' | 'edit';
export type GetConditionalStepType = {
  actionToPerform: ActionToPerform;
  isDeliveryMethodSelectionStepVisited: boolean;
  isCapitalOneRail: boolean;
  deliveryMethod?: DeliveryMethod | null;
  deliveryMethodIdFromState?: string;
  isFinancingSelected?: boolean;
  memoToVendorDeliveryMethodBlackList: DeliveryMethodType[];
};

export const getConditionalSteps = ({
  actionToPerform,
  isDeliveryMethodSelectionStepVisited,
  deliveryMethodIdFromState,
  deliveryMethod,
  isFinancingSelected,
  isCapitalOneRail,
  memoToVendorDeliveryMethodBlackList,
}: GetConditionalStepType) => {
  const skipDeliveryMethodStep = getSkipDeliveryMethodStep(
    actionToPerform,
    isDeliveryMethodSelectionStepVisited,
    deliveryMethod,
    deliveryMethodIdFromState
  );
  const skipMemoToVendorStep = getSkipMemoToVendorStep({
    deliveryMethod,
    isCapitalOneRail,
    memoToVendorDeliveryMethodBlackList,
  });

  return {
    hasDeliveryMethodStep: !skipDeliveryMethodStep,
    hasPaymentPurposeStep: deliveryMethod?.type === DeliveryMethodType.InternationalAccount,
    hasMemoToVendorStep: !skipMemoToVendorStep,
    hasRepaymentTermsStep: isFinancingSelected,
  };
};
